import { render } from "./VideoThumbnail.vue?vue&type=template&id=335d6498"
import script from "./VideoThumbnail.vue?vue&type=script&lang=js"
export * from "./VideoThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__